import {type List, type Map} from 'immutable';

import {createAction as oldCreateAction} from 'web-app/util/redux/famly-app-helpers';
import {createAction, createAllActions} from 'web-app/util/redux/typed-action-helpers';
import type BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import {type Warning, type Invoice, type DateTimePeriod} from './types';

const domain = 'APPS/BATCH_INVOICE';

export const {action: showingInstitutionId} = createAction(
    `${domain}/SHOWING_INSTITUTION_ID`,
    (institutionId?: string) => ({
        institutionId,
    }),
);

export const {success: fetchInvoicingBillPayersSuccess, failed: fetchInvoicingBillPayersFailed} = createAllActions(
    `${domain}/FETCH_INVOICING_BILL_PAYERS`,
    () => ({}),
    (payload: {
        billPayerIds: List<string>;
        warnings: List<Warning>;
        useGraphQl: boolean;
        invoices: Map<string, Invoice[]>;
        behaviors: BehaviorsCollection;
    }) => ({
        payload,
    }),
);

export const {action: fetchAllData, failed: fetchAllDataFailed} = createAllActions(
    `${domain}/FETCH_ALL_DATA`,
    (
        institutionId: string,
        fetchPeriod: DateTimePeriod,
        invoicePeriod: DateTimePeriod,
        isBatchInvoicingLimited: boolean,
    ) => ({
        institutionId,
        fetchPeriod,
        invoicePeriod,
        isBatchInvoicingLimited,
    }),
    (message: string) => ({message}),
);

export const {action: showMoreWarnings} = createAction(`${domain}/SHOW_MORE_WARNINGS`, () => ({}));

export const {
    action: batchInvoice,
    success: batchInvoiceSuccess,
    failed: batchInvoiceFailed,
    aborted: batchInvoiceAborted,
} = createAllActions(
    `APPS/BATCH_INVOICE/BATCH_INVOICE`,
    (
        institutionId: string,
        billPayerIds: string[],
        invoiceData: DateTimePeriod,
        confirmText: string,
        useGraphQl: boolean,
    ) => ({
        institutionId,
        billPayerIds,
        invoiceData,
        confirmText,
        useGraphQl,
    }),
    (runIds: string[]) => ({runIds}),
);

export const {success: previewBatchInvoiceSuccess, failed: previewBatchInvoiceFailed} = createAllActions(
    `${domain}/PREVIEW_BATCH_INVOICE`,
    () => ({}),
    (payload: {invoicePreviews: any; isBatchInvoicingLimited: boolean}) => ({payload}),
);

export const {action: selectBillPayer} = oldCreateAction(
    `${domain}/SELECT_BILLPAYER`,
    (billPayerId: string, select: boolean) => ({
        billPayerId,
        select,
    }),
);

export const {action: selectBillPayerWithRadioButton} = oldCreateAction(
    `${domain}/SELECT_BILLPAYER_WITH_RADIO_BUTTON`,
    (billPayerId: string, select: boolean) => ({
        billPayerId,
        select,
    }),
);

export const {action: selectAllBillPayers} = createAction(
    `${domain}/SELECT_ALL_BILLPAYERS`,
    (select: boolean, billPayerIdsBeingShown: List<string>) => ({
        select,
        billPayerIdsBeingShown,
    }),
);

// Dispatched when the entire batch invoicing progress is completed
// (Incl. waiting for the batch invoicing "run" to enter the "SUCCESS" state)
export const {action: batchInvoicingRunCompleted} = createAction(`${domain}/BATCH_INVOICING_RUN_COMPLETED`, () => ({}));
